import { StoreVersionsView } from "@CommonApi/merchflows/_merchflowId_/stores/_storeCode_";

export const getStorePogDeleteCounts = (
  selection: number[],
  stores: StoreVersionsView[],
): { inProgressCount: number; approvedCount: number } => {
  const storeMap = new Map(stores.map((s) => [s.storePog.storePogId, s]));
  let inProgressCount = 0;
  let approvedCount = 0;

  for (const id of selection) {
    const store = storeMap.get(id);
    if (!store) continue;

    if (
      store.storePog.status === "NOT_STARTED" ||
      store.storePog.status === "POGGER_IN_PROGRESS" ||
      store.storePog.status === "UPDATE_IN_PROGRESS"
    ) {
      inProgressCount++;
    }

    if (store.storePog.isApproved) {
      approvedCount++;
    }
  }

  return { inProgressCount, approvedCount };
};
